import { render } from "./ctrl-btn-click-dbclick.vue?vue&type=template&id=37543696&scoped=true&ts=true"
import script from "./ctrl-btn-click-dbclick.vue?vue&type=script&lang=ts"
export * from "./ctrl-btn-click-dbclick.vue?vue&type=script&lang=ts"

import "./ctrl-btn-click-dbclick.vue?vue&type=style&index=0&id=37543696&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37543696"]])

export default __exports__